import { Presentation, TSlide } from "../lib/types";
import { Theme } from "../lib/types";
const bgImg = require("./img/pinky.png");
const gitHooksLogo = require("./img/githooks/git-hooks-logo.png");
const runPowershellImg = require("./img/githooks/code.png");
const gitHooksFolder = require("./img/githooks/githooks-folder.png");

const theme = {
	primaryColor: "rgb(63,0,121)",
	secondaryColor: "rgb(240,240,240)",
	transition: "fade",
	rootFontSize: "28pt",
} as Theme;

const slides = [
	{
		content: `
# Automate Everything: Git Hooks

![22h Git hooks logo](${gitHooksLogo})

`,
		justify: "-",
	},
	{
		content: `

# What are git hooks?

Git has events that you can _hook_ into.

They allow you to run scripts whenever the associated event is triggered.
`,
		justify: "v",
	},
	{
		content: `
# Examples of hook events

- applypatch-msg
- commit-msg
- fsmonitor-watchman
- post-update
- pre-applypatch
- pre-commit
- pre-push
- pre-rebase
- pre-receive
- prepare-commit-msg
- update
`,
		justify: "v",
		notes: `
Go to next to highlight pre-commit
`,
	},
	{
		content: `
# Examples of hook events

- applypatch-msg
- commit-msg
- fsmonitor-watchman
- post-update
- pre-applypatch
  - **pre-commit**
- pre-push
- pre-rebase
- pre-receive
- prepare-commit-msg
- update
`,
		justify: "v",
		notes: `
A noteworthy one is pre-commit which is run before a commit is made.
This one has the ability to intercept the commit and block it programmatically which is the functionality that I'm going to be focusing on
`,
	},

	{
		content: `
## Writing a git hook

Git hooks can be found in the .git/hooks/ directory which is at the root of every git repository.

![h32](${gitHooksFolder})
`,
		notes: `By default the hooks directory has a load of samples in it that you can modify and use`,
		justify: "^",
		style: {},
	},
	{
		content: `
## Writing a git hook

#### Git hooks are written in bash by default but you can execute any script within them.

![w60](${runPowershellImg})
`,
		notes: `
I use powershell because I don't really know bash.
`,
		style: {},
	},
	{
		content: `
## DEMO: Git hook in action
`,
		justify: "-",
		notes: `
1. Open VSCode and show hello world of pre-commit.
2. Show the TODO blocking script in action within VSCode
        `,
	},
	{
		content: `
# Resources

General resources

[GitHooks.com](https://githooks.com/)

Add a random emoji to every commit 🙏

[Podmena](https://github.com/bmwant/podmena)

TODO example

[github.com/box-of-hats/git-snippets](https://github.com/Box-Of-Hats/Git-Snippets)
    `,
		justify: "v",
		notes: `Podmena - This is a really fun idea because whenever you're talking about commits, you can now refer to them by the emoji.
"Who broke the build?"
"It was the eggplant emoji"
        `,
		style: {},
	},
] as TSlide[];

const presentation: Presentation = {
	slides: slides,
	title: "Automate Everything: Git Hooks",
	style: {
		backgroundImage: `url(${bgImg})`,
	},
	theme: theme,
};

export default presentation;
